import { Translatable, TranslateProperty } from '../../../core/helper/translatables';
import { ModelBase } from '../../../core/model/model-base';
import { B2CSubscriptionContactAction, B2CSubscriptionContactActionToString } from '../const/enum-b2c';
import { B2CSubscriptionIdentity } from './b2c-subscription-identity';

// TODO: needs history sql table of when contacts are mapped to / unmapped from a B2CSubscriptionIdentity
// An event on the relation between a contact and a subscription
export class B2CSubscriptionContactEvent extends ModelBase {
  constructor() {
    super();
    TranslateProperty(this as B2CSubscriptionContactEvent, 'action', B2CSubscriptionContactActionToString);
  }

  identity: B2CSubscriptionIdentity;
  action: Translatable<B2CSubscriptionContactAction>;

  dateUtc: Date;
  contactId: string;

  /**
   * Describes which import subscription event triggered the system to create this contact (mapping) event.
   * User triggered contact events doesn't have a corresponding import event.
   */
  importEventId?: string;

  toString(culture?: string): string {
    return B2CSubscriptionContactActionToString(this.action.valueOf());
  }

  public static Map(source: B2CSubscriptionContactEvent): B2CSubscriptionContactEvent {
    if (!source) {
      return null;
    }
    const obj = Object.assign(new B2CSubscriptionContactEvent(), source);
    obj.identity = B2CSubscriptionIdentity.Map(source.identity);
    return obj;
  }
}
